import { ToggleButtonGroup } from '../ToggleButtonGroup';
import { Box, ToggleButtonProps, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

type DaysSelectProps = {
  options?: { value: string; label: string }[];
  selectedValue?: number[] | string[];
  onChange?: (value: any) => void;
  disabled?: boolean;
  error?: string;
  props?: Record<string, any>;
};

const days = [
  {
    value: 0,
    label: 'main:days.monday',
  },
  {
    value: 1,
    label: 'main:days.tuesday',
  },
  {
    value: 2,
    label: 'main:days.wednesday',
  },
  {
    value: 3,
    label: 'main:days.thursday',
  },
  {
    value: 4,
    label: 'main:days.friday',
  },
  {
    value: 5,
    label: 'main:days.saturday',
  },
  {
    value: 6,
    label: 'main:days.sunday',
  },
];

export const DaysSelect = ({
  options,
  selectedValue = [],
  onChange = () => {},
  disabled = false,
  error,
  ...props
}: DaysSelectProps) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <ToggleButtonGroup
        data-testid="days-select"
        buttons={(options ?? days).map((day) => ({
          value: day.value,
          content: t(day.label),
          buttonProps: {
            size: 'large' as ToggleButtonProps['size'],
            sx: {
              fontSize: 12,
              '&.Mui-selected': {
                backgroundColor: (theme) => theme.palette.brand.main,
                color: (theme) => theme.palette.common.white,
                '&.Mui-disabled': {
                  backgroundColor: (theme) => theme.palette.grey[400],
                  color: (theme) => theme.palette.grey[600],
                },
              },
            },
          },
        }))}
        selectedValue={selectedValue || []}
        onChange={onChange}
        fullWidth
        disabled={disabled}
        {...props}
      />
      {error && (
        <Typography color="error" variant="caption" sx={{ mt: 1 }}>
          {error}
        </Typography>
      )}
    </Box>
  );
};
